<template>
    <div class="vehicle-link container">
        <div class="row h-50">
            <div class="col-12">
              <!-- <p>Android URI <a href="oneapptoyota://sms/registration">oneapptoyota://sms/registration</a></p>
              <p>iOS URI <a href="oneapptoyota://sms/registration">oneapptoyota://sms/registration</a></p> -->
            </div>
            <div class="col my-4">
                <h2 class="message">To connect your Vehicle to OneApp, enter your mobile number.</h2>
                <p>
                    <label class="message" for="phone">Mobile Number</label>
                    <input class="form-control"
                      id="phone"
                      v-model="phone"
                      type="text"
                      name="phone">
                </p>
                <div class="py-3" style="text-align: center">
                    <button class="ty-button" v-on:click="sendLink">Send link</button>
                </div>
                <div class="py-3" style="text-align: center">
                    <p>After receiving the link and launching OneApp visit the QR scan page (QR-IDP).</p>
                    <p>You should receive this link on your mobile device. <a href="https://toyota-one.app.link/U30MFxXiyZ">https://toyota-one.app.link/U30MFxXiyZ</a></p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Branch from 'branch-sdk';
  export default {
    name: "VehicleLink",
    data: function(){
      return{
        errors: [],
        phone:null
      }
    },
    methods: {
      // checkForm: function () {
      //   if (this.phone) {
      //     return true;
      //   }
      //   this.errors = [];
      //
      //   if (!this.phone) {
      //     this.errors.push('A valid mobile number is required.');
      //   }
      //   else{
      //     this.generate();
      //   }
      // },
      sendLink: function () {
        alert(`SMS sent to ${this.phone}`)
        //Branch.init('key_live_gnSEzFNyt77pHgZ17MC6LjonDBiucgKP')
        Branch.init('key_live_foKqNMt9x9ONKJJyXysQIhjcBFfWJwNR')
        Branch.sendSMS(
          this.phone,
          {
            tags: ['vehicle-link'],
            channel: 'hu',
            feature: 'register',
            stage: 'connect',
            data: {
              mydata: 'registration',
              foo: 'bar',
              '$ios_deeplink_path': 'sms/registration',
              '$deeplink_path': 'sms/registration',
              '$android_deeplink_path': 'sms/registration',
            }
          },
          { make_new_link: false }, // Default: false. If set to true, sendSMS will generate a new link even if one already exists.
          function(err) {
            alert(err.toString())
          }
        )
      }
    }
  }
</script>

<style scoped>
    .vehicle-link{
      color:#000000;
    }
    a {
        color:#000000;
    }
    .music-link{
        background-color: #217CF6;
    }
    .message{
        color:#000000;
    }
    .ty-button{
        background: #D92429;
        border-radius: 0px;
        width:343px;
        height:64px;
        font-family: ToyotaType-Semibold;
        font-size: 24px;
        color: #FFFFFF;
        letter-spacing: 0.73px;
        text-align: center;
    }
</style>
